<template>
  <v-btn class="btn-return" @click="$router.go(-1)">
    <i class="fas fa-arrow-left mr-2"></i> Voltar
  </v-btn>
</template>

<script>
export default {
  name: "VBtnPreviousPage",
};
</script>